import { REDUX_STORE } from '@funnels/constants';
import { OtherActionTypes, OtherReducerState, SharedActionTypes } from '@funnels/types';

const initialState: OtherReducerState = {
  error: null,
};

export default function assetsReducer(
  state: OtherReducerState = initialState,
  action: OtherActionTypes | SharedActionTypes
): OtherReducerState {
  switch (action.type) {
    case REDUX_STORE.SHARED_ACTION_TYPES.CLEAR_ERROR:
    case REDUX_STORE.OTHER.ACTION_TYPES.CLEAR_OTHER_ERROR:
      return {
        ...state,
        error: null,
      };
    case REDUX_STORE.OTHER.ACTION_TYPES.SET_OTHER_ERROR:
      return {
        ...state,
        error: {
          message: action.message,
        },
      };
    default:
      return state;
  }
}
